/* tslint:disable */
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by a tool.
//
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import Vue from "vue";
export const PrintScheduleModal = "Modal-printScheduleModal";
Vue.component(PrintScheduleModal, (resolve) => (require as any)(["@app/calendar/printScheduleModal.vue"], module => {
    resolve(module.default);
}));
export const EditProviderAvailabilityModal = "Modal-editProviderAvailabilityModal";
Vue.component(EditProviderAvailabilityModal, (resolve) => (require as any)(["@app/calendar/providerAvailability/editProviderAvailabilityModal.vue"], module => {
    resolve(module.default);
}));
export const AddClinicalNoteModal = "Modal-addClinicalNoteModal";
Vue.component(AddClinicalNoteModal, (resolve) => (require as any)(["@app/clinicalNote/addClinicalNoteModal.vue"], module => {
    resolve(module.default);
}));
export const NewMessageModal = "Modal-newMessageModal";
Vue.component(NewMessageModal, (resolve) => (require as any)(["@app/message/conversation/newMessageModal.vue"], module => {
    resolve(module.default);
}));
export const ProviderAccreditationModal = "Modal-providerAccreditationModal";
Vue.component(ProviderAccreditationModal, (resolve) => (require as any)(["@app/profile/professionalDetails/providerAccreditationModal.vue"], module => {
    resolve(module.default);
}));
export const CompleteReportModal = "Modal-completeReportModal";
Vue.component(CompleteReportModal, (resolve) => (require as any)(["@app/reportAttachment/completeReportModal.vue"], module => {
    resolve(module.default);
}));
export const AttachmentUploadModal = "Modal-attachmentUploadModal";
Vue.component(AttachmentUploadModal, (resolve) => (require as any)(["@app/shared/components/attachmentUploadModal/attachmentUploadModal.vue"], module => {
    resolve(module.default);
}));
export const TermsAndConditionsModal = "Modal-termsAndConditionsModal";
Vue.component(TermsAndConditionsModal, (resolve) => (require as any)(["@app/shared/components/termsAndConditions/termsAndConditionsModal.vue"], module => {
    resolve(module.default);
}));
export const PrintTravelModal = "Modal-printTravelModal";
Vue.component(PrintTravelModal, (resolve) => (require as any)(["@app/travel/printTravelModal.vue"], module => {
    resolve(module.default);
}));
export const AccommodationDetailsModal = "Modal-accommodationDetailsModal";
Vue.component(AccommodationDetailsModal, (resolve) => (require as any)(["@app/travel/travelDetails/accommodationDetailsModal.vue"], module => {
    resolve(module.default);
}));
export const FlightDetailsModal = "Modal-flightDetailsModal";
Vue.component(FlightDetailsModal, (resolve) => (require as any)(["@app/travel/travelDetails/flightDetailsModal.vue"], module => {
    resolve(module.default);
}));
export const FileUploadedNotificationModal = "Modal-fileUploadedNotificationModal";
Vue.component(FileUploadedNotificationModal, (resolve) => (require as any)(["@app/reportAttachment/fileUploadedNotificationModal.vue"], module => {
    resolve(module.default);
}));
export const OdgSearchDurationModal = "Modal-odgSearchDurationModal";
Vue.component(OdgSearchDurationModal, (resolve) => (require as any)(["@app/ebmResource/odgSearchDurationModal.vue"], module => {
    resolve(module.default);
}));
export const PatientAttendanceCommentsModal = "Modal-patientAttendanceCommentsModal";
Vue.component(PatientAttendanceCommentsModal, (resolve) => (require as any)(["@app/appointment/patientAttendanceCommentsModal.vue"], module => {
    resolve(module.default);
}));
export const ChangePatientAttendanceDateTimeModal = "Modal-changePatientAttendanceDateTimeModal";
Vue.component(ChangePatientAttendanceDateTimeModal, (resolve) => (require as any)(["@app/appointment/changePatientAttendanceDateTimeModal.vue"], module => {
    resolve(module.default);
}));
export const ServiceOptionSelectPopupModal = "Modal-serviceOptionSelectPopupModal";
Vue.component(ServiceOptionSelectPopupModal, (resolve) => (require as any)(["@app/service/_serviceOptionSelectModal.vue"], module => {
    resolve(module.default);
}));